import {tealiumTracker} from '@src/Services/Tealium';
import type {
  TealiumAuthProps,
  TealiumSubscriptionCompletedProps,
} from '@src/Services/Tealium';

/**
 * Tealium-only event firing, kept isolated from the canonical Amplitude/Braze
 * catalog (Tracking/catalog/events.ts) so the Vodafone Tealium data-layer spec
 * can be implemented/evolved without touching internal analytics routing.
 */

const currentPath = (): string =>
  typeof window !== 'undefined' ? window.location.pathname : '/';

export const trackTealiumLoginSuccessful = (
  props: TealiumAuthProps & {pageSection?: string} = {},
): void => tealiumTracker.auth.loginSuccessful(currentPath(), props);

export const trackTealiumSignupSuccessful = (
  props: TealiumAuthProps & {pageSection?: string} = {},
): void => tealiumTracker.auth.signupSuccessful(currentPath(), props);

export const trackTealiumSignout = (pageSection?: string): void =>
  tealiumTracker.auth.signout(currentPath(), pageSection);

export const trackTealiumSubscriptionCompleted = (
  props: TealiumSubscriptionCompletedProps = {},
): void => tealiumTracker.subscription.completed(currentPath(), props);
